<template>
	<div class="contentbox">
		<div class="media-add-video-list">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<!--<el-form-item label="小程序" prop="appId" v-if="!isAgent">-->
					<!--<app-list @getAppId="getAppId" :appId="formInline.appId" clear="noclear"></app-list>-->
					<!--</el-form-item>-->
					<el-form-item label="短剧名" prop="svName">
						<el-input v-model="formInline.svName" placeholder="请输入短剧名" clearable @keyup.enter.native="search"
							@clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="短剧ID" prop="svId">
						<el-input type="number" v-model="formInline.svId" placeholder="请输入短剧ID" clearable
							@keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="状态" prop="rackStatus" style="margin-right: 30px;">
						<el-select v-model="formInline.rackStatus" placeholder="请选择状态" clearable @change="search"
							style="width: 150px;">
							<el-option v-for="item in rackStatusOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否推荐" prop="haveRec" style="margin-right: 30px;">
						<el-select v-model="formInline.haveRec" placeholder="请选择状态" clearable @change="search"
							style="width: 150px;">
							<el-option v-for="item in haveRecOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<div class="fr">
						<el-form-item>
							<el-button v-has="'info:add'" type="success" icon="el-icon-circle-plus-outline"
								@click="addData">添加</el-button>
						</el-form-item>
						<el-form-item v-has="'info:batch'">
							<!--<el-button type="danger">批量操作</el-button>-->
							<el-dropdown trigger="click">
								<el-button type="danger" size="small" :disabled="idList.length > 0 ? false : true">
									批量操作<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item @click.native="handleUpOrDown(1)">批量上架</el-dropdown-item>
									<el-dropdown-item @click.native="handleUpOrDown(0)">批量下架</el-dropdown-item>
									<el-dropdown-item @click.native="handleExportex">批量导出</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe @selection-change="handleSelectionChange" style="width: 100%"
					height="100%" class="tableStyle" v-loading="loadingTabel">
					<!-- :selectable="onSelectable" -->
					<el-table-column type="selection" width="60" align="center">
					</el-table-column>
					<el-table-column prop='' label="序号" width="60">
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column label="短剧信息" width="230">
						<template slot-scope="scope">
							<div class="td-info">
								<p>短剧名：{{ scope.row.videolistVo.svName }}</p>
								<p>别名：{{ scope.row.videolistVo.aliasName }}</p>
								<p>短剧ID：{{ scope.row.svId }}</p>
								<p>剧目ID：{{ scope.row.albumId }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="剧集信息" width="130">
						<template slot-scope="scope">
							<div class="td-info">
								<p>总集数：{{ scope.row.videolistVo.sumEps }}</p>
								<p>更新集数：{{ scope.row.videolistVo.upEps }}</p>
								<p>
									是否完结：
									<span v-if="scope.row.videolistVo.writingStatus == 0" class="primary-text">未完结</span>
									<span v-if="scope.row.videolistVo.writingStatus == 1" class="succes-text">完结</span>
								</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="封面" width="130">
						<template slot-scope="scope">
							<img class="cover" :src="scope.row.videolistVo.coverPath" />
						</template>
					</el-table-column>
					<el-table-column label="解锁剧集信息" width="190">
						<template slot-scope="scope">
							<div class="td-info">
								<p>免费集数：{{ scope.row.userFreeEp }}</p>
								<p>每集金币数：{{ scope.row.epPrice }}</p>
								<p>解锁模式：
									<span v-if="scope.row.priceFlag == 0">纯付费解锁</span>
									<!-- <span v-if="scope.row.priceFlag == 1">纯整剧付费</span> -->
									<span v-if="scope.row.priceFlag == 2">纯广告解锁</span>
									<span v-if="scope.row.priceFlag == 3">单集付费+广告解锁</span>
								</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="其他信息" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>
									角标：
									<span v-if="scope.row.cornerMarker == 0" class="primary-text">不开启</span>
									<span v-if="scope.row.cornerMarker == 1" class="succes-text">开启</span>
								</p>
								<p>推荐语：{{ scope.row.videolistVo.longRecText }}</p>
								<p>类目标签：{{ scope.row.labelInfo }}</p>
								<p>绑定小程序：{{ scope.row.bindAppidName }}</p>
								<p>充值分成：{{ scope.row.rechargeShare }}%</p>
								<p>广告分成：{{ scope.row.adShare }}%</p>
								<p v-if="platform != 'wx-sv' && platform != 'wx-gg-sv'">播放默认倍速：{{ scope.row.videolistVo.speed }}x</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="haveRec" label="是否推荐展示" width="120">
						<template slot-scope="scope">
							<span v-if="scope.row.haveRec == 0">否</span>
							<span v-if="scope.row.haveRec == 1">是</span>
						</template>
					</el-table-column>
					<el-table-column prop="isVerify" label="状态" width="100" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.rackStatus == 0" class="danger-text">已下架</span>
							<span v-if="scope.row.rackStatus == 1" class="succes-text">上架中</span>
						</template>
					</el-table-column>
					<el-table-column prop="addTime" label="添加时间" width="160">
					</el-table-column>
					<el-table-column prop="addTime2" label="剧上架时间" width="160">
						<template slot-scope="scope">
							<p>开始时间：</p>
							<p>{{ scope.row.onlineStartTime || '' }} </p>
							<p>结束时间：</p>
							<p>{{ scope.row.onlineEndTime || '' }} </p>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="350" fixed="right">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini"
								@click="handleLook(scope.row.id)">详情</el-button>
							<el-button v-has="'info:update'" type="primary" icon="el-icon-edit" size="mini"
								@click="handleEdit(scope.row.id)">编辑</el-button>
							<el-popover v-has="'info:delete'" width="160" :ref="scope.row.id" style="margin-left: 10px;">
								<p class="popover-con del">
									<i class="el-icon-question warnning-text"></i>确定删除吗？
								</p>
								<div style="text-align: right;">
									<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
									<el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
								</div>
								<el-button slot="reference" type="danger" icon="el-icon-delete"
									:disabled="scope.row.rackStatus == 1 ? true : false" size="mini">删除</el-button>
							</el-popover>
							<el-dropdown v-has="'info:more'" trigger="click" style="margin-left: 10px;">
								<el-button type="success" size="mini">
									更多<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="addVid"
										@click.native="handleAddEpisodeDitch(scope.row.id)">一键填充剧集ID</el-dropdown-item>
									<el-dropdown-item command="configVid"
										@click.native="handleSyncConfigContent(scope.row.id)">同步配置内容</el-dropdown-item>
									<el-dropdown-item command="configVid" :disabled="scope.row.rackStatus == 0"
										@click.native="onPreviewSeries(scope.row)">预览剧集</el-dropdown-item>
									<el-dropdown-item command="configVid" @click.native="onRecommend(scope.row)">
										{{ scope.row.haveRec == 1 ? '关闭推荐' : '打开推荐' }}
									</el-dropdown-item>
									<el-dropdown-item v-if="platform == 'wx-sv' || platform == 'wx-gg-sv'" command="configVid"
										@click.native="copyAlbumid(scope.row)">复制albumid</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
						:page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background :current-page="currentPage"
						layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
					<tr>
						<td width="200">短剧信息</td>
						<td>
							<p>总集数：{{ ruleForm.videolistVo.sumEps }}</p>
							<p>更新集数：{{ ruleForm.videolistVo.upEps }}</p>
							<p>
								是否完结：
								<span v-if="ruleForm.videolistVo.writingStatus == 0" class="primary-text">未完结</span>
								<span v-if="ruleForm.videolistVo.writingStatus == 1" class="succes-text">完结</span>
							</p>
						</td>
					</tr>
					<tr>
						<td>封面</td>
						<td>
							<img class="cover" :src="ruleForm.videolistVo.coverPath" />
						</td>
					</tr>
					<tr>
						<td>解锁剧集信息</td>
						<td>
							<p>免费集数：{{ ruleForm.userFreeEp }}</p>
							<p>每集金币数：{{ ruleForm.epPrice }}</p>
							<p>解锁模式：
								<span v-if="ruleForm.priceFlag == 0">纯付费解锁</span>
								<!-- <span v-if="ruleForm.priceFlag == 1">纯整剧付费</span> -->
								<span v-if="ruleForm.priceFlag == 2">纯广告解锁</span>
								<span v-if="ruleForm.priceFlag == 3">单集付费+广告解锁</span>
							</p>
						</td>
					</tr>
					<tr>
						<td>其他信息</td>
						<td>
							<div>
								<p>
									角标：
									<span v-if="ruleForm.cornerMarker == 0" class="primary-text">不开启</span>
									<span v-if="ruleForm.cornerMarker == 1" class="succes-text">开启</span>
								</p>
								<p>推荐语：{{ ruleForm.videolistVo.longRecText }}</p>
								<p>类目标签：{{ ruleForm.labelInfo }}</p>
								<p>绑定小程序：{{ ruleForm.bindAppid }}</p>
								<p>充值分成：{{ ruleForm.rechargeShare }}%</p>
								<p>广告分成：{{ ruleForm.adShare }}%</p>
								<p v-if="platform != 'wx-sv' && platform != 'wx-gg-sv'">播放默认倍速：{{ ruleForm.videolistVo.speed }}x</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>状态</td>
						<td>
							<span v-if="ruleForm.rackStatus == 0" class="danger-text">已下架</span>
							<span v-if="ruleForm.rackStatus == 1" class="succes-text">上架中</span>
						</td>
					</tr>
					<tr>
						<td>是否推荐展示</td>
						<td>
							<span v-if="ruleForm.haveRec == 0">否</span>
							<span v-if="ruleForm.haveRec == 1">是</span>
						</td>
					</tr>
					<tr>
						<td>添加时间</td>
						<td>{{ ruleForm.addTime }}</td>
					</tr>
					<tr>
						<td>剧上架时间</td>
						<td>
							<p>开始时间：{{ ruleForm.onlineStartTime || '' }}</p>
							<p>结束时间：{{ ruleForm.onlineEndTime || '' }}</p>
						</td>
					</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!--修改弹框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="700px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" class="input350" size="small"
				style="max-height: 550px;overflow: auto; padding-right: 20px;">
				<el-form-item label="选择短剧：" prop="videoId">
					<el-tag closable @close="handleCloseTagVideo" v-if="ruleForm.videolistVo.svName"
						style="margin-right: 10px;">{{
							ruleForm.videolistVo.svName }}</el-tag>
					<el-button type="primary" size="small" @click="isShowDialogVideo = true">选择</el-button>
					<el-input v-model="ruleForm.videoId" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="别名：" prop="videolistVo.aliasName">
					<el-input v-model="ruleForm.videolistVo.aliasName" placeholder="请输入短剧别名"></el-input>
				</el-form-item>
				<el-form-item label="封面图：">
					<el-upload class="avatar-uploader" action="short/video/info/uploadImage" :show-file-list="false"
						:on-change="(file, fileList) => handleUpimg('picUrl', file, fileList)">
						<img v-if="ruleForm.videolistVo.coverPath" :src="ruleForm.videolistVo.coverPath" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<p class="upimgId" v-if="ruleForm.videolistVo.picId">图片id：{{ ruleForm.videolistVo.picId }}</p>
				</el-form-item>
				<el-form-item label="总集数：" prop="videolistVo.sumEps" :rules="rules.sumEps">
					<el-input type="number" v-model="ruleForm.videolistVo.sumEps" placeholder="请输入总集数"></el-input>
				</el-form-item>
				<el-form-item label="已更新集数：" prop="videolistVo.upEps" :rules="rules.upEps">
					<el-input type="number" v-model="ruleForm.videolistVo.upEps" placeholder="请输入已更新集数"></el-input>
				</el-form-item>
				<el-form-item label="是否完结：" prop="videolistVo.writingStatus">
					<el-switch v-model="ruleForm.videolistVo.writingStatus" active-color="#13ce66" inactive-color="#ff4949"
						:active-value="1" :inactive-value="0">
					</el-switch>
				</el-form-item>
				<el-form-item label="免费集数：" prop="userFreeEp">
					<el-input type="number" v-model="ruleForm.userFreeEp" placeholder="请输入免费集数数"></el-input>
				</el-form-item>
				<el-form-item label="每集金币数：" prop="epPrice">
					<el-input type="number" v-model="ruleForm.epPrice" placeholder="请输入每一集金币数"></el-input>
				</el-form-item>
				<el-form-item label="短剧解锁模式：" prop="priceFlag">
					<el-select v-model="ruleForm.priceFlag" filterable clearable placeholder="请选择短剧解锁模式">
						<el-option v-for="item in priceFlagOptions" :key="item.value" :label="item.label" :value="item.value"
							:disabled="item.disabled">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="整剧价格：" prop="finishPrice" v-if="ruleForm.priceFlag == 1">
					<el-input type="number" v-model="ruleForm.finishPrice" placeholder="请输入整剧价格(兜底)"></el-input>
				</el-form-item>
				<el-form-item label="封面角标：" prop="cornerMarker">
					<el-switch v-model="ruleForm.cornerMarker" active-color="#13ce66" inactive-color="#ff4949" :active-value="1"
						:inactive-value="0">
					</el-switch>
				</el-form-item>
				<el-form-item label="角标文案：" prop="cornerContent">
					<el-input v-model="ruleForm.cornerContent" placeholder="请输入角标文案"
						style="width: 180px; float: left;"></el-input>
					<div class="block" style="display: inline-block; float: left; margin-left: 15px; height: 32px;">
						<el-color-picker v-model="ruleForm.cornerColor"></el-color-picker>
					</div>
				</el-form-item>
				<el-form-item label="推荐语：" prop="videolistVo.longRecText">
					<el-input v-model="ruleForm.videolistVo.longRecText" maxlength="20" placeholder="请输入12个汉字以内的推荐语"></el-input>
				</el-form-item>
				<el-form-item label="短剧简介：" prop="videolistVo.intro">
					<el-input type="textarea" v-model="ruleForm.videolistVo.intro" placeholder="请输入200字以内短剧简介" :rows="5"
						maxlength="200" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="短剧类目：" prop="wxCategoryId" v-if="platform=='wx-sv' || platform=='wx-gg-sv'">
					<el-select v-model="firstCate" clearable placeholder="请选择一级类目" @change="handleSelectfirstCate"
						style="width: 150px;">
						<el-option v-for="item in firstCateOptions" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<el-select v-model="secondCate" clearable placeholder="请选择二级类目" @change="handleSelectSecondCate"
						style="width: 150px;margin-left: 10px;">
						<el-option v-for="item in secondCateOptions" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<el-select v-model="threeCate" clearable placeholder="请选择三级类目" @change="handleSelectThreeCate"
						style="width: 150px;margin-left: 10px;">
						<el-option v-for="item in threeCateOptions" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="短剧标签：" prop="labelInfoList">
					<el-select v-model="ruleForm.labelInfoList" clearable multiple :multiple-limit="3"
						placeholder="请选择短剧标签，最多选择3个" @change="handleSelectLabel">
						<el-option v-for="item in labelListOptions" :key="item.tagname" :label="item.tagname" :value="item.tagname">
						</el-option>
					</el-select>
					<!--<el-input v-model="ruleForm.labelInfoList" style="display: none;"></el-input>-->
				</el-form-item>
				<el-form-item label="选择小程序：">
					<el-tag closable v-for="(item, index) in selectApp" :key="index" @close="handleCloseTagApp(index)"
						style="margin-right: 10px;">{{ item.name }}</el-tag>
					<el-button type="primary" size="small" @click="isShowDialogApp = true">选择</el-button>
					<!-- <div class="input-note">不选支持所有小程序展示</div> -->
					<el-input v-model="ruleForm.bindAppid" style="display: none;"></el-input>
					<el-input v-model="ruleForm.bindAppidName" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="播放默认倍速：" prop="videolistVo.speed" v-if="platform != 'wx-sv' && platform != 'wx-gg-sv'">
					<el-select v-model="ruleForm.videolistVo.speed" filterable clearable placeholder="请选择播放默认倍速">
						<el-option v-for="item in speedOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="分成比例：" prop="ShareRate">
					<el-input v-model="ruleForm.rechargeShare" style="width: 200px; float: left;">
						<template slot="prepend">充值</template>
						<template slot="append">%</template>
					</el-input>
					<el-input v-model="ruleForm.adShare" style="width: 200px; float: left;margin-left: 10px">
						<template slot="prepend">广告</template>
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
				<el-form-item label="剧上架时间：" prop="onlineTime">
					<el-date-picker v-model="onlineTime" type="datetimerange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
				</el-form-item>
				<!--<el-form-item label="选择小程序：" prop="bindAppid">-->
				<!--<app-list @getAppId="getAppId" :appId="ruleForm.bindAppid"></app-list>-->
				<!--</el-form-item>-->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<!--修改弹框-->
		<el-dialog title="同步配置内容" :visible.sync="configFormVisible" width="700px">
			<el-form :rules="configRules" ref="configRuleForm" :model="configRuleForm" label-width="150px" class="input350"
				size="small" style="max-height: 550px;overflow: auto; padding-right: 20px;">
				<el-form-item label="同步至：" prop="appIdson">
					<el-select v-model="appIdson" filterable clearable placeholder="请选择小程序" style="width: 280px;">
						<el-option v-for="item in appOptions" :key="item.appId" :label="item.name" :value="item.appId"
							:disabled="item.disabled || false"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="configFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="configEditDialogSureBtn('configRuleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 预览剧集 -->
		<el-dialog title="预览" top="5vh" :visible.sync="dialogViewVisible" width="600px" @closed="handleDialogClosed">
			<div class="preview-img" v-if="seriesList.videoEpisodeDitch">
				<div class="preview-title">{{ seriesList.videoEpisodeDitch.epTitle }}</div>
				<div class="video-demo">
					<video v-if="seriesList.videoEpisodeDitch" id="videoPlayer" class="video-js vjs-default-skin" controls
						playsinline autoplay="autoplay" width="420px">
						<source :src="seriesList.videoEpisodeDitch.epContent"
							:type="isM3U8 ? 'application/x-mpegURL' : 'video/mp4'" />
					</video>
				</div>
				<div class="dialog-footer" style="margin-top: 20px;">
					<el-button plain size="mini" :disabled="seriesList.videoEpisodeDitch.epNumber == 1"
						@click="changePage(seriesList.videoEpisodeDitch.epNumber - 1)">上一页</el-button>
					<span class="page-size"> <span>&nbsp;{{ seriesList.videoEpisodeDitch.epNumber }}</span>&nbsp;/&nbsp;{{
						seriesList.sumEps }}&nbsp;</span>
					<el-button plain size="mini" :disabled="seriesList.videoEpisodeDitch.epNumber == seriesList.sumEps"
						@click="changePage(seriesList.videoEpisodeDitch.epNumber + 1)">下一页</el-button>
					<span style="margin: 0 5px 0 10px;">前往</span>
					<el-input v-model="pageVal" size="mini" type="number" :min="1" :step='1' style="width: 60px;"
						@change="changePageVal(seriesList.sumEps)"></el-input>
					<span style="margin-left: 5px;">页</span>
				</div>
			</div>
		</el-dialog>
		<!-- 上下架时间不符合提示 -->
		<el-dialog title="提示" :visible.sync="frameDialogVisible" width="600px" @closed="frameDialogVisible = false">
			<p>选中的 <span style="font-weight: 600;color: #67C23A;">{{ notFrameStr }}</span>，当前时间不符合剧的上下架时间，无法进行上/下架，请重新选择。</p>
			<span slot="footer" class="dialog-footer">
				<el-button @click="frameDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="frameDialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>

		<video-table-media :visible.sync="isShowDialogVideo" :selectVideo="selectVideo" @videoSure="videoSure"
			@cancelDialogVideo="cancelDialogVideo"></video-table-media>
		<app-table-more :visible.sync="isShowDialogApp" :selectApp="selectApp" @appSure="appSure"
			@cancelDialogApp="cancelDialogApp"></app-table-more>
	</div>
</template>
<script>
import VideoTableMedia from '@/components/VideoTableMedia'
import AppTableMore from '@/components/AppTableMore'
import { listVideo, details, addVideo, del, upOrDown, listLabel, addEpisodeDitch } from "@/api/dysvzk/video/manage";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import categoryData from '@/assets/js/categoryData.json';
export default {
	components: {
		VideoTableMedia,
		AppTableMore,
	},
	data() {
		var validateNum = (rule, value, callback) => {
			if (!(/(^[1-9]\d*$)/.test(value))) {
				return callback(new Error('数字应为正整数'));
			} else {
				callback();
			}
		};
		var validateAppIdson = (rule, value, callback) => {
			if (!this.appIdson) {
				return callback(new Error('请选择同步小程序'));
			} else {
				callback();
			}
		};
		return {
			loadingTabel: false,
			formInline: {
				appId: localStorage.getItem('appId'),
				svId: '',
				svName: '',
				rackStatus: '',
				haveRec: ''
			},
			rackStatusOptions: [
				{
					value: 0,
					label: '已下架'
				},
				{
					value: 1,
					label: '上架中'
				}
			],
			priceFlagOptions: [
				{
					value: 0,
					label: '纯付费解锁'
				},
				// {
				// 	value: 1,
				// 	label: '纯整剧付费',
				// 	disabled: true
				// },
				{
					value: 2,
					label: '纯广告解锁'
				},
				{
					value: 3,
					label: '单集付费+广告解锁'
				}
			],
			speedOptions: [
				{
					value: '0.75',
					label: '0.75x'
				},
				{
					value: '1',
					label: '1.0x'
				},
				{
					value: '1.25',
					label: '1.25x'
				},
				{
					value: '1.5',
					label: '1.5x'
				},
				{
					value: '2',
					label: '2.0x'
				},
			],
			idList: [],
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 1,
				result: []
			},
			currentPage: 1,
			dialogInfoVisible: false, // 详情弹框
			dialogTitle: '添加',
			dialogFormVisible: false, // 编辑弹框
			updateType: 'add',
			labelListOptions: [],
			ruleForm: {
				addTime: '',
				albumId: '',
				bindAppid: '',
				cornerContent: '',
				cornerColor: '#FF4640',
				cornerMarker: 1,
				epPrice: '',
				id: '',
				labelInfo: '',
				priceFlag: '',
				rackStatus: '',
				svId: '',
				updateType: '',
				userFreeEp: '',
				videoId: '',
				videolistVo: {
					aliasName: '',
					coverPath: '',
					intro: '',
					longRecText: '',
					picId: '',
					sumEps: '',
					svName: '',
					upEps: '',
					writingStatus: 0,
					speed: "1.25"
				},
				finishPrice: '',
				rechargeShare: '',
				adShare: '',
				wxCategoryId: '',
				wxCategoryName: ''
			},
			rules: {
				videoId: [
					{ required: true, message: '请选择短剧', trigger: 'change' }
				],
				picId: [
					{ required: true, message: '请选择短剧', trigger: 'change' }
				],
				bindAppid: [
					{ required: true, message: '请选择绑定小程序', trigger: 'change' }
				],
				// cornerContent: [
				//     {required: true, message: '请输入角标内容', trigger: 'blur'}
				// ],
				epPrice: [
					{ required: true, message: '请输入每一集金币数', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				],
				labelInfoList: [
					{ required: true, message: '请选择短剧类目标签', trigger: 'change' }
				],
				priceFlag: [
					{ required: true, message: '请选择付费模式', trigger: 'change' }
				],
				rackStatus: [
					{ required: true, message: '请选择状态', trigger: 'change' }
				],
				userFreeEp: [
					{ required: true, message: '请输入免费集数', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				],
				// aliasName: [
				//     {required: true, message: '请输入别名', trigger: 'blur'}
				// ],
				// coverPath: [
				//     {required: true, message: '请上传封面图', trigger: 'blur'}
				// ],
				intro: [
					{ required: true, message: '请输入简介', trigger: 'blur' }
				],
				longRecText: [
					{ required: true, message: '请输入推荐语', trigger: 'blur' }
				],
				sumEps: [
					{ required: true, message: '请输入总集数', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				],
				upEps: [
					{ required: true, message: '请输入已更新集数', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				],
				svName: [
					{ required: true, message: '请选择短剧', trigger: 'change' }
				],
				writingStatus: [
					{ required: true, message: '请选择短剧更新状态', trigger: 'change' }
				],
				finishPrice: [
					{ required: true, message: '请选择输入整剧价格', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				],
				// wxCategoryId: [
				// 	{ required: true, message: '请选择输入短剧类目', trigger: 'blur' },
				// ]
			},
			isShowDialogVideo: false,
			selectVideo: {},
			isShowDialogApp: false,
			selectApp: [],
			isAgent: false,
			configFormVisible: false,
			configRuleForm: {
				// appIdson:''
			},
			appIdson: '',
			configRules: {
				appIdson: [
					{ validator: validateAppIdson, trigger: 'change' },
				],
			},
			appOptions: [
				{
					appId: '',
					name: '',
					disabled: false,
				}
			],
			dialogViewVisible: false,//预览剧集
			seriesList: {},
			previewSvId: '',
			pageVal: '',
			dp: null,
			isM3U8: false,
			options: {
				playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
				// aspectRatio:'9:16',
				notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
				autoplay: false, // 设置自动播放
				inactivityTimeout: 0,
				muted: true, // 设置了它为true，才可实现自动播放,同时视频也被静音（Chrome66及以上版本，禁止音视频的自动播放）
				preload: "auto", // 预加载
				controls: true, // 显示播放的控件
			},
			onlineTime: [],
			haveRecOptions: [
				{
					value: 0,
					label: '否'
				},
				{
					value: 1,
					label: '是'
				}
			],
			platform: localStorage.getItem('platform'),
			notFrameList: null,//选中的，未在时间范围的
			notFrameStr: null,
			svIdList: [],//选中的svid
			frameDialogVisible: false,
			firstCate: '',
			firstCateOptions: [
				{
					name: '男频',
					id: 185437
				},
				{
					name: '女频',
					id: 185438
				},
			],
			secondCate: '',
			secondCateOptions: [],
			threeCate: '',
			threeCateOptions: [],
		}
	},
	computed: {},
	watch: {
	},
	mounted: function () {
		if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
			this.isAgent = true
			this.formInline.appId = JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId
		}
		this.getTableData()
		this.getLabelList()
		this.initialCategory()
	},
	beforeDestroy() {
	},
	methods: {
		// 初始化类目
		initialCategory(){
			if (this.platform == 'wx-sv' || this.platform == 'wx-gg-sv') {
				if (categoryData && categoryData.length > 0) {
					this.secondCateOptions = categoryData.map(item => {
						return {
							name: item.name,
							id: item.id
						}
					})
					let threeCate = []
					categoryData.forEach(item => {
						threeCate.push(...item.subcategory)
					})
					this.threeCateOptions = [...threeCate]
				}
			}
		},
		// 从组件获取appid
		getAppId(data) {
			this.formInline.appId = data
			this.getTableData()
		},
		// 关闭选剧弹窗
		cancelDialogVideo(data) {
			console.log('cancel')
			this.isShowDialogVideo = data
		},
		// 确定剧
		videoSure(data) {
			console.log("确定剧", data)
			this.ruleForm.videolistVo.svName = data.title
			this.ruleForm.videoId = data.id
			this.ruleForm.videolistVo.coverPath = data.picUrl
			this.ruleForm.videolistVo.picId = data.picId
			this.ruleForm.videolistVo.aliasName = data.title
			this.ruleForm.videolistVo.sumEps = data.sumEps
			this.ruleForm.videolistVo.upEps = data.sumEps
			this.ruleForm.videolistVo.writingStatus = data.videoUpdateStatus == 0 ? 0 : 1
			this.ruleForm.videolistVo.intro = data.introduce
			this.ruleForm.videolistVo.longRecText = data.recommendDescribe
			this.selectVideo = data
		},
		// 删除所选剧
		handleCloseTagVideo(tag) {
			console.log(tag)
			this.ruleForm.videolistVo.svName = ''
			this.ruleForm.videoId = ''
			this.ruleForm.videolistVo.coverPath = ''
			this.ruleForm.videolistVo.picId = ''
			this.selectVideo = {}
		},
		// 关闭选小程序弹窗
		cancelDialogApp(data) {
			console.log('cancel')
			this.isShowDialogApp = data
		},
		// 确定小程序
		appSure(data) {
			this.ruleForm.bindAppname = data.appname
			this.ruleForm.bindAppid = data.appid
			this.selectApp = [data.currentRow]
			console.log("this.selectApp", this.selectApp)
		},
		// 删除所选小程序
		handleCloseTagApp(index) {
			var appIdList = []
			var appNameList = []
			this.selectApp.splice(index, 1)
			if (this.selectApp.length > 0) {
				this.selectApp.forEach((item) => {
					appIdList.push(item.appId)
					appNameList.push(item.name)
				})
				this.ruleForm.bindAppid = appIdList.toString()
				this.ruleForm.bindAppname = appNameList.toString()
			} else {
				this.ruleForm.bindAppid = ''
				this.ruleForm.bindAppname = ''
			}
		},
		search() {
			this.currentPage = 1
			this.getTableData()
		},
		resetQuery() {
			this.formInline.appId = 'ttf0a0861d6f92acd301'
			this.$refs['formInline'].resetFields()
			this.getTableData()
			// console.log(formName)
			// this.$refs[formName].resetFields()
			// this.getTableData()
		},
		// 添加表格
		addData() {
			// const appInfo = JSON.parse(localStorage.getItem('appList')).filter(item => item.appId === this.formInline.appId)
			// this.dialogTitle = appInfo[0].name + ' · 添加'
			this.dialogTitle = '添加'
			this.ruleForm = {
				bindAppid: '',
				cornerContent: '',
				cornerColor: '#FF4640',
				cornerMarker: 1,
				epPrice: '',
				id: '',
				labelInfo: '',
				labelInfoList: [],
				priceFlag: '',
				rackStatus: '',
				updateType: 'add',
				userFreeEp: '',
				videoId: '',
				videolistVo: {
					aliasName: '',
					coverPath: '',
					intro: '',
					longRecText: '',
					picId: '',
					sumEps: '',
					svName: '',
					upEps: '',
					writingStatus: 0,
					speed: '1.25'
				},
				finishPrice: '',
				rechargeShare: '',
				adShare: '',
				wxCategoryId: '',
				wxCategoryName: ''
			}
			this.selectVideo = {}
			this.selectApp = []
			if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].clearValidate(['labelInfo'])
				this.$refs['ruleForm'].resetFields()
			}
			this.initialCategory()
			this.firstCate = ''
			this.secondCate = ''
			this.threeCate = ''
			this.dialogFormVisible = true
		},
		handleLook(id) {
			console.log(id)
			this.dialogInfoVisible = true
			this.getDetails(id, 'look')
		},
		// 删除
		handleDelete(id) {
			console.log(id)
			del({
				infoId: id
			}).then(response => {
				if (response.data.head.flag === 0) {
					if (this.tableData.result.length === 1 && this.currentPage > 1) {
						this.currentPage = this.currentPage - 1
					}
					this.$refs[id].doClose()
					this.getTableData()
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		// 编辑
		handleEdit(id) {
			console.log(id)
			if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
			// const appInfo = JSON.parse(localStorage.getItem('appList')).filter(item => item.appId === this.formInline.appId)
			// this.dialogTitle = appInfo[0].name + ' · 编辑'
			this.dialogTitle = '编辑'
			this.dialogFormVisible = true
			this.getDetails(id, 'edit')
		},
		// 获取详情
		getDetails(id, text) {
			this.selectApp = []
			details({
				infoId: id,
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.ruleForm = response.data.content
					if (response.data.content.onlineStartTime) {
						this.onlineTime = [response.data.content.onlineStartTime, response.data.content.onlineEndTime]
					} else {
						this.onlineTime = []
					}

					const appList = JSON.parse(localStorage.getItem('appList'))
					const appArr = this.ruleForm.bindAppid.split(",")
					appList.map(item => {
						if (appArr.includes(item.appId)) {
							this.selectApp.push(item)
						}
					})
					// 设置短剧类目
					if(this.ruleForm.wxCategoryId){
						const categoryArr = this.ruleForm.wxCategoryId.split(",")
						this.firstCate = Number(categoryArr[0])
						this.secondCate = Number(categoryArr[1])
						this.threeCate = Number(categoryArr[2])
						const cateOptions = categoryData.filter(cate => {
							return cate.id == this.secondCate
						})
						if(cateOptions && cateOptions.length > 0){
							this.threeCateOptions = cateOptions[0].subcategory
						}
					}else{
						this.firstCate = ''
						this.secondCate = ''
						this.threeCate = ''
					}

					if (text == 'edit') {
						this.ruleForm.updateType = 'edit'
						console.log(this.ruleForm.labelInfo)
					}
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		// 弹框确定
		editDialogSureBtn(formName) {
			console.log(this.ruleForm)
			if(this.firstCate && this.secondCate && this.threeCate){
				this.ruleForm.wxCategoryId =`${this.firstCate},${this.secondCate},${this.threeCate}`
				const firstCateName = this.firstCateOptions.filter(item => item.id == this.firstCate)[0].name
				const secondCateName = this.secondCateOptions.filter(item => item.id == this.secondCate)[0].name
				const threeCateName = this.threeCateOptions.filter(item => item.id == this.threeCate)[0].name
				this.ruleForm.wxCategoryName =`${firstCateName || ''},${secondCateName || ''},${threeCateName || ''}`
			}else{
				this.ruleForm.wxCategoryId = ''
				this.ruleForm.wxCategoryName = ''
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					console.log(this.ruleForm.updateType)
					this.saveTableData()
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 保存编辑信息
		saveTableData() {
			const paramJson = {
				...this.ruleForm,
				onlineStartTime: this.onlineTime[0],
				onlineEndTime: this.onlineTime[1]
			}
			console.log("保存", paramJson)
			addVideo(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.getTableData()
					this.dialogFormVisible = false
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		// 批量上下架
		handleUpOrDown(rack) {
			if (rack == 1 && this.notFrameList.length > 0) {
				this.notFrameStr = this.notFrameList.join(',')
				this.frameDialogVisible = true;
				return;
			}
			upOrDown({
				rackStatus: rack,
				strategyIdList: this.idList
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.$message({
						message: response.data.head.desc,
						type: 'success'
					});
					this.getTableData()
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		getLabelList() {
			listLabel({
				pageNo: this.currentPage,
				pageSize: this.tableData.pageSize
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.labelListOptions = response.data.content.result
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		getTableData() {
			this.loadingTabel = true
			let json2 = {
				pageNo: this.currentPage,
				pageSize: this.tableData.pageSize
			};
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2 };
			listVideo(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.tableData = response.data.content
				} else {
					this.$message.error(response.data.head.desc)
				}
				this.loadingTabel = false
			});
		},
		handleCurrentChange(value) {
			this.currentPage = value
			this.getTableData()
		},
		handleSizeChange(val) {
			this.tableData.pageSize = val
			this.currentPage = 1
			this.getTableData()
		},
		handleSelectionChange(val) {
			var that = this
			that.idList = []
			that.notFrameList = []
			that.svIdList = []
			const currentTime = new Date().getTime()
			val.forEach((item) => {
				that.idList.push(item.id)
				that.svIdList.push(item.svId)
				if (item.onlineStartTime && item.onlineEndTime) {
					if (currentTime <= this.stringToDate(item.onlineStartTime) || currentTime >= this.stringToDate(item.onlineEndTime)) {
						that.notFrameList.push(item.videolistVo.svName)
					}
				}
			})
		},
		// 标签类目
		handleSelectLabel(val) {
			console.log(val.toString())
		},
		// 一键填充id
		handleAddEpisodeDitch(id) {
			addEpisodeDitch({
				infoId: id,
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.getTableData()
					this.$message({
						message: '填充成功',
						type: 'success'
					});
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		// 图片上传
		handleUpimg(text, file, fileList) {
			console.log(file, fileList);
			console.log(text);
			if (file.status === 'success') {
				if (file.response.head.flag === 0) {
					this.ruleForm.videolistVo.coverPath = file.response.content.imgPath
					this.ruleForm.videolistVo.picId = file.response.content.imgId
					this.$notify({
						title: '上传成功',
						message: '上传成功',
						type: 'success'
					})
					this.$refs['ruleForm'].clearValidate(text)
				} else {
					this.$message.error(file.response.data.head.desc)
				}
			} else if (file.status === 'fail') {
				// console.log(file.status)
				this.$notify.error({
					title: '上传失败',
					message: '上传失败，请重新再传'
				})
				this.ruleForm.picUrl = ''
			}
		},

		//同步配置内容
		handleSyncConfigContent(id) {
			this.configFormVisible = true
			this.appIdson = ''
			if (this.$refs['configRuleForm'] !== undefined) {
				this.$refs['configRuleForm'].resetFields()
			}
			details({
				infoId: id,
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.configRuleForm = response.data.content
					this.configRuleForm.updateType = 'edit'
					const appList = JSON.parse(localStorage.getItem('appList'))
					appList.forEach(item => {
						if (this.configRuleForm.bindAppid.split(',').includes(item.appId)) {
							item.disabled = true
						}
					})
					this.appOptions = appList

				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},

		//确定同步配置内容
		configEditDialogSureBtn(formName) {
			this.configRuleForm.bindAppid = this.appIdson
			this.configRuleForm.id = ''
			this.configRuleForm.updateType = 'add'
			// console.log("thiddd",this.appIdson,this.configRuleForm)
			this.$refs[formName].validate((valid) => {
				if (valid) {
					addVideo(this.configRuleForm).then(response => {
						if (response.data.head.flag === 0) {
							this.$message({
								message: '提交成功',
								type: 'success'
							});
							this.getTableData()
							this.configFormVisible = false
						} else {
							this.$message.error(response.data.head.desc);
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 预览剧集
		onPreviewSeries(row) {
			this.dialogViewVisible = true
			this.previewSvId = row.svId
			this.pageVal = 1
			this.getPlaying()
		},
		// 获取当前预览剧集
		getPlaying(number = 1) {
			// 销毁旧的播放器
			if (this.dp) {
				this.dp.dispose();
				this.dp = null;
			}
			// 清空当前剧集信息
			this.seriesList.videoEpisodeDitch = null;
			// 重新获取剧集信息
			this.axios({
				method: 'get',
				url: '/video/episodeDitch/playing',
				params: {
					epNumber: number,
					svId: this.previewSvId
				}
			}).then((response) => {
				if (response.data.head.flag == 0) {
					this.seriesList = response.data.content
					// 判断视频格式
					const url = new URL(this.seriesList.videoEpisodeDitch.epContent);
					this.isM3U8 = url.pathname.endsWith('.m3u8');
					// 初始化播放器实例
					this.$nextTick(() => {
						const videoElement = document.getElementById('videoPlayer');
						if (videoElement) {
							this.dp = videojs(videoElement, this.options);
						} else {
							console.error("Video player element not found");
						}

					});
				} else {
					this.$message.error(response.data.head.desc);
				}

			})
		},

		// 预览中切换视频
		changePage(number) {
			this.pageVal = number
			this.getPlaying(number)
		},
		changePageVal(sumEps) {
			if (this.pageVal > sumEps) {
				this.pageVal = sumEps
				this.$message.error(`最多只有${sumEps}条视频！`)
			}
			if (this.pageVal < 1) {
				this.pageVal = 1
				this.$message.error(`至少需要1条视频！`)
			}
			this.getPlaying(this.pageVal)
		},
		// 关闭剧集预览弹窗
		handleDialogClosed() {
			// 销毁播放器并清空数据
			if (this.dp) {
				this.dp.dispose();
				this.dp = null;
			}
			this.seriesList.videoEpisodeDitch = null
		},
		//多选框是否可选
		// onSelectable(row){
		// 	console.log("row",row)
		// 	const currentTime = new Date().getTime()
		// 	let startTime = null
		// 	let endTime = null
		// 	if(row.onlineStartTime) {
		// 		startTime = this.stringToDate(row.onlineStartTime)
		// 	}

		// 	if(row.onlineEndTime) {
		// 		endTime = this.stringToDate(row.onlineEndTime)
		// 	}

		// 	if(startTime && endTime){
		// 		return currentTime >= startTime && currentTime <= endTime
		// 	}else{
		// 		return true
		// 	}

		// },
		// 字符串转时间戳
		stringToDate(time) {
			// 将日期时间字符串转换为 ISO 格式（确保兼容性）
			const isoDateString = time.replace(" ", "T")
			const date = new Date(isoDateString)
			const timestampMilliseconds = date.getTime()
			return timestampMilliseconds

		},
		// 打开或关闭推荐
		onRecommend(row) {
			console.log("打开或关闭推荐", row)
			this.axios({
				method: 'get',
				url: '/video/strategy/updateRec',
				params: {
					haveRec: row.haveRec == 0 ? 1 : 0,
					infoId: row.id
				}
			}).then((response) => {
				if (response.data.head.flag == 0) {
					this.getTableData()
					this.$message({
						message: `${row.haveRec == 0 ? '已打开' : '已关闭'}推荐`,
						type: 'success'
					});
				} else {
					this.$message.error(response.data.head.desc);
				}

			})

		},
		// 微信获取抖音albumid并复制
		copyAlbumid(row) {
			this.axios({
				method: 'post',
				url: '/video/strategy/wxGetDyAlbumId',
				params: {
					appid: this.formInline.appId,
					infoId: row.id
				}
			}).then((response) => {
				if (response.data.head.flag == 0) {
					console.log("获取albumid成功", response.data)
					this.copyText(response.data.content)
				} else {
					this.$message.error(response.data.head.desc);
				}

			})

		},
		// 批量导出
		handleExportex() {
			const svIdStr = this.svIdList.join(',')
			this.axios({
				method: 'get',
				url: '/video/strategy/export',
				responseType: 'blob',
				params: {
					appId: this.formInline.appId,
					haveRec: this.formInline.haveRec,
					rackStatus: this.formInline.rackStatus,
					svId: this.formInline.svId,
					svName: this.formInline.svName,
					svIdStr: svIdStr,
				}
			}).then((response) => {
				const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const fileName = '短剧列表.xlsx'; // 修改为你期望的文件名
				const url = window.URL.createObjectURL(file);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', fileName); // 设置下载文件名
				document.body.appendChild(link);
				link.click();
			})
		},

		// 选择一级类目
		handleSelectfirstCate(val) {
			console.log('选择一级类目', val)
			if (!categoryData || categoryData.length == 0) {
				this.$message.error('暂无类目标签！');
				return;
			}
			this.secondCateOptions = categoryData.map(item => {
				return {
					name: item.name,
					id: item.id
				}
			})
			this.secondCate = this.secondCateOptions[0].id || []
		},
		// 选择二级类目
		handleSelectSecondCate(val) {
			console.log('选择二级类目', val)
			if (!categoryData || categoryData.length == 0) {
				this.$message.error('暂无类目标签！');
				return;
			}
			const CateOptions = categoryData.filter(cate => {
				return cate.id == val
			})
			if(CateOptions && CateOptions.length > 0){
				this.threeCateOptions = CateOptions[0].subcategory
			}else{
				this.threeCateOptions = []
			}
			this.threeCate = this.threeCateOptions[0]?.id || []
		},
		// 选择三级类目
		handleSelectThreeCate(val) {
			console.log('选择三级类目', val)
			if (!categoryData || categoryData.length == 0) {
				this.$message.error('暂无类目标签！');
				return;
			}
			for (const cate of categoryData) {
				if (cate.subcategory.some(sub => sub.id === val)) {
					this.secondCate = cate.id;
					// this.secondCateOptions = [
					// 	{
					// 		name: cate.name,
					// 		id: cate.id
					// 	}
					// ]
				}
			}
		},

		// 通用复制
		copyText(url) {
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(url).then(() => {
					this.$message({
						message: `复制成功`,
						type: 'success'
					})
				}).catch(err => {
					console.log(err)
					this.$message({
						message: `复制失败`,
						type: 'error'
					})
				})
			}
			if (!navigator.clipboard) {
				let oInput = document.createElement('input')
				oInput.value = url
				document.body.appendChild(oInput)
				oInput.select() // 选择对象
				document.execCommand("Copy") // 执行浏览器复制命令
				this.$message({
					message: `复制成功`,
					type: 'success'
				})
				oInput.remove()
			}
		},

	}
}
</script>
<style lang="scss" scoped>
.preview-img {
	width: 100%;
	text-align: center;

	.preview-title {
		font-size: 16px;
		margin: -60px 0 30px 0;
	}

	.video-demo {
		width: 100%;
		height: 100%;
	}

	video {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
		/* 保持视频比例 */
	}

}
</style>
